import axios from 'axios';
import * as uuid from 'uuid';
import {GetCoordsByAddressResponse, GetInspectionsInsideBordersResponse} from '../types';
import {RequestCancellationManager} from '../../../../utils';

export class InspectionsMapAPI {
  static API = {
    getInspectionsInsideBorders: 'inspectionsMap/getInspectionsInsideBorders',
    getCoordsByAddress: 'inspectionsMap/getCoordsByAddress'
  };
  static prefixes = {
    getInspectionsInsideBorders: 'get-inspections-inside-borders',
    getCoordsByAddress: 'get-coords-by-address'
  };

  public async getInspectionsInsideBorders(
    fromLatitude: number,
    fromLongitude: number,
    toLatitude: number,
    toLongitude: number,
    fromDate = '',
    toDate = '',
    cityID = -1,
    streetID = -1,
  ) {
    RequestCancellationManager.stopRequests(InspectionsMapAPI.prefixes.getInspectionsInsideBorders);
    const requestID = `${InspectionsMapAPI.prefixes.getInspectionsInsideBorders}-${uuid.v4()}`;
    const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);
    const result = await axios.get<GetInspectionsInsideBordersResponse>(InspectionsMapAPI.API.getInspectionsInsideBorders, {
      params: {
        fromLatitude,
        fromLongitude,
        toLatitude,
        toLongitude,
        fromDate,
        toDate,
        cityID,
        streetID
      },
      ...cancellationHandlers
    });

    if (result.data.errorCode !== 0) throw new Error();

    return result.data.body;
  }

  public async getCoordsByAddress(address: string) {
    RequestCancellationManager.stopRequests(InspectionsMapAPI.prefixes.getCoordsByAddress);
    const requestID = `${InspectionsMapAPI.prefixes.getCoordsByAddress}-${uuid.v4()}`;
    const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);
    const result = await axios.get<GetCoordsByAddressResponse>(InspectionsMapAPI.API.getCoordsByAddress, {
      params: {
        address
      },
      ...cancellationHandlers
    });

    if (result.data.errorCode !== 0) throw new Error();

    return result.data.body.coordinates;
  }
}